// extracted by mini-css-extract-plugin
export default {"react_pdf_document":"file_react_pdf_document__UF4fi","react_pdf_pages":"file_react_pdf_pages__Xuyxe"};